import { all, fork, takeEvery, takeLatest } from "redux-saga/effects";

import {
  FETCH_AUTHORIZED_CAMPAGNES_REQUEST,
  CREATE_CAMPAGNE_REQUEST,
  DELETE_CAMPAGNE_REQUEST,
  FETCH_BUDGET_BY_CAMPAGNE_REQUEST,
  FETCH_CAMPAGNES_REQUEST,
  FETCH_VISIBLE_CAMPAGNES_REQUEST,
  UPDATE_CAMPAGNE_REQUEST,
} from "../../actions/campagnesActions";
import {
  createCampagneSaga,
  deleteCampagneSaga,
  fetchAuthorizedCampagnesSaga,
  fetchBudgetByCampagneSaga,
  fetchCampagnesSaga,
  fetchVisibleCampagnesSaga,
  updateCampagneSaga,
} from "../../sagas/campagnesSaga";

import {
  CREATE_DOMAINE_REQUEST,
  CREATE_THEME_REQUEST,
  DELETE_DOMAINE_REQUEST,
  DELETE_THEME_REQUEST,
  DOWNLOAD_DOMAINES_TEMPLATE_REQUEST,
  DOWNLOAD_THEMES_TEMPLATE_REQUEST,
  FETCH_DOMAINES_REQUEST,
  FETCH_THEMES_BY_DOMAINE_REQUEST,
  FETCH_THEMES_REQUEST,
  IMPORT_DOMAINES_EXCEL_REQUEST,
  IMPORT_THEMES_EXCEL_REQUEST,
  UPDATE_DOMAINE_REQUEST,
  UPDATE_THEME_REQUEST,
} from "../../actions/paramDomainesThemesActions";
import {
  createDomaineSaga,
  createThemeSaga,
  deleteDomaineSaga,
  deleteThemeSaga,
  downloadDomainesTemplateSaga,
  downloadThemesTemplateSaga,
  fetchDomainesSaga,
  fetchThemesByDomaineSaga,
  fetchThemesSaga,
  importDomainesExcelSaga,
  importThemesExcelSaga,
  updateDomaineSaga,
  updateThemeSaga,
} from "../../sagas/paramDomainesThemesSaga";

import {
  CREATE_FORMATION_REQUEST,
  DELETE_FORMATION_REQUEST,
  DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST,
  EXPORT_FORMATIONS_REQUEST,
  FETCH_FORMATIONS_BY_CATALOGUE_REQUEST,
  FETCH_FORMATIONS_REQUEST,
  IMPORT_FORMATIONS_EXCEL_REQUEST,
  UPDATE_FORMATION_REQUEST,
} from "../../actions/formationsActions";
import {
  createFormationSaga,
  deleteFormationSaga,
  downloadTemplateSaga,
  exportExcelSaga,
  fetchFormationsByCatalogueSaga,
  fetchFormationsSaga,
  importExcelSaga,
  updateFormationSaga,
} from "../../sagas/formationsSaga";

import {
  CREATE_CATALOGUE_REQUEST,
  DELETE_CATALOGUE_REQUEST,
  FETCH_CATALOGUES_REQUEST,
  UPDATE_CATALOGUE_REQUEST,
} from "../../actions/cataloguesActions";
import {
  createCatalogueSaga,
  deleteCatalogueSaga,
  fetchCataloguesSaga,
  updateCatalogueSaga,
} from "../../sagas/cataloguesSaga";

import {
  CREATE_CAPSULE_REQUEST,
  DELETE_CAPSULE_REQUEST,
  GET_CAPSULE_REQUEST,
  GET_CAPSULES_REQUEST,
  GET_DOMAINES_REQUEST,
  GET_THEMES_BY_DOMAINE_REQUEST,
  UPDATE_CAPSULE_REQUEST,
} from "../../actions/capsuleActions";
import {
  createCapsuleSaga,
  deleteCapsuleSaga,
  getCapsuleSaga,
  getCapsulesSaga,
  getDomainesSaga,
  getThemesByDomaineSaga,
  updateCapsuleSaga,
} from "../../sagas/capsuleSaga";

import {
  CANCEL_EVENT_DEMANDE_REQUEST,
  CREATE_DEMANDE_COLLAB_REQUEST,
  CREATE_DEMANDE_MANAGER_BULK_REQUEST,
  CREATE_DEMANDE_MANAGER_REQUEST,
  CREATE_DEMANDE_RF_BULK_REQUEST,
  CREATE_DEMANDE_RF_REQUEST,
  CREATE_EVENT_DEMANDE_BY_LEARNER_REQUEST,
  CREATE_EVENT_DEMANDE_BY_MANAGER_REQUEST,
  CREATE_EVENT_DEMANDE_BY_RF_REQUEST,
  DEMANDE_MANAGER_DECISION_REQUEST,
  DEMANDE_RF_DECISION_REQUEST,
  DOWNLOAD_BILAN_FORMATION_REQUEST,
  DOWNLOAD_PLAN_FORMATION_REQUEST,
  FETCH_PARTICIPATION_CAMPAGNE_REQUEST,
  GET_COMPANY_DEMANDES_REQUEST,
  GET_CREATED_BY_ME_DEMANDES_REQUEST,
  GET_DEMANDE_TRACKING_REQUEST,
  GET_DEMANDE_MANAGER_INBOX_REQUEST,
  GET_DEMANDE_RF_INBOX_REQUEST,
  GET_DEMANDES_CAMPAGNE_REQUEST,
  GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST,
  GET_MY_DEMANDES_REQUEST,
  GET_MY_FORMATION_DEMANDES_REQUEST,
  PROLONGER_CAMPAGNE_REQUEST,
  RELANCE_PARTICIPATION_CAMPAGNE_REQUEST,
  RELANCE_WORKFLOW_CAMPAGNE_REQUEST,
  RELANCE_WORKFLOW_DEMANDE_REQUEST,
  WITHDRAW_EVENT_DEMANDE_REQUEST,
} from "../../actions/demandesActions";
import {
  cancelEventDemandeSaga,
  createDemandeCollabSaga,
  createDemandeManagerBulkSaga,
  createDemandeManagerSaga,
  createDemandeRfBulkSaga,
  createDemandeRfSaga,
  createEventDemandeByLearnerSaga,
  createEventDemandeByManagerSaga,
  createEventDemandeByRfSaga,
  demandeManagerDecisionSaga,
  demandeRfDecisionSaga,
  downloadGenerateBilanCampagneExcelSaga,
  downloadGeneratePlanFormationExcelSaga,
  fetchParticipationCampagneSaga,
  getCompanyDemandesSaga,
  getCreatedByMeDemandesSaga,
  getDemandeTrackingSaga,
  getDemandeManagerInboxSaga,
  getDemandeRfInboxSaga,
  getDemandesCampagneSaga,
  getDemandesManagerCampagneSaga,
  getMyDemandesSaga,
  getMyFormationDemandesSaga,
  prolongerCampagneSaga,
  relanceParticipationCampagneSaga,
  relanceWorkflowCampagneSaga,
  relanceWorkflowDemandeSaga,
  withdrawEventDemandeSaga,
} from "../../sagas/demandesSaga";

import watchFormationBookmarksSaga from "../../sagas/formationBookmarksSaga";

import {
  CREATE_SALLE_REQUEST,
  DELETE_SALLE_REQUEST,
  FETCH_SALLES_REQUEST,
  UPDATE_SALLE_REQUEST,
} from "../../actions/sallesActions";
import {
  createSalleSaga,
  deleteSalleSaga,
  fetchSallesSaga,
  updateSalleSaga,
} from "../../sagas/sallesSaga";

import {
  CREATE_FOURNISSEUR_REQUEST,
  DELETE_FOURNISSEUR_REQUEST,
  FETCH_FOURNISSEURS_REQUEST,
  UPDATE_FOURNISSEUR_REQUEST,
} from "../../actions/fournisseursActions";
import {
  createFournisseurSaga,
  deleteFournisseurSaga,
  fetchFournisseursSaga,
  updateFournisseurSaga,
} from "../../sagas/fournisseursSaga";

import {
  CREATE_CONSULTANT_REQUEST,
  DELETE_CONSULTANT_REQUEST,
  FETCH_CONSULTANTS_REQUEST,
  UPDATE_CONSULTANT_REQUEST,
} from "../../actions/consultantsActions";
import {
  createConsultantSaga,
  deleteConsultantSaga,
  fetchConsultantsSaga,
  updateConsultantSaga,
} from "../../sagas/consultantsSaga";

import {
  CREATE_MODULE_CLE_REQUEST,
  DELETE_MODULE_CLE_REQUEST,
  DOWNLOAD_MODULE_CLE_TEMPLATE_REQUEST,
  FETCH_MODULES_CLE_REQUEST,
  IMPORT_MODULE_CLE_EXCEL_REQUEST,
  UPDATE_MODULE_CLE_REQUEST,
} from "../../actions/modulesCleActions";
import {
  createModuleCleSaga,
  deleteModuleCleSaga,
  downloadModuleCleTemplateSaga,
  fetchModulesCleSaga,
  importModuleCleExcelSaga,
  updateModuleCleSaga,
} from "../../sagas/modulesCleSaga";

import {
  CREATE_MODULE_REQUEST,
  DELETE_MODULE_REQUEST,
  GET_ALL_MODULES_REQUEST,
  GET_CHILD_MODULES_REQUEST,
  GET_MODULE_REQUEST,
  GET_MODULES_BY_STATUS_REQUEST,
  GET_ROOT_MODULES_REQUEST,
  UPDATE_MODULE_REQUEST,
} from "../../actions/moduleActions";
import {
  createModuleSaga,
  deleteModuleSaga,
  getAllModulesSaga,
  getChildModulesSaga,
  getModuleSaga,
  getModulesByStatusSaga,
  getRootModulesSaga,
  updateModuleSaga,
} from "../../sagas/moduleSaga";

import {
  CREATE_MODULE_SECTION_REQUEST,
  DELETE_MODULE_SECTION_REQUEST,
  GET_MODULE_SECTIONS_REQUEST,
  REORDER_MODULE_SECTIONS_REQUEST,
  UPDATE_MODULE_SECTION_REQUEST,
} from "../../actions/moduleCleSectionActions";
import {
  createModuleSectionSaga,
  deleteModuleSectionSaga,
  getModuleSectionsSaga,
  reorderModuleSectionsSaga,
  updateModuleSectionSaga,
} from "../../sagas/moduleCleSectionSaga";

import {
  CREATE_MODULECLE_CONTENT_REQUEST,
  DELETE_MODULECLE_CONTENT_REQUEST,
  GET_MODULECLE_CONTENT_REQUEST,
  GET_MODULECLE_CONTENTS_REQUEST,
  REORDER_MODULECLE_CONTENTS_REQUEST,
  UPDATE_MODULECLE_CONTENT_REQUEST,
} from "../../actions/moduleCleContentActions";
import {
  createModuleCleContentSaga,
  deleteModuleCleContentSaga,
  getModuleCleContentSaga,
  getModuleCleContentsSaga,
  reorderModuleCleContentsSaga,
  updateModuleCleContentSaga,
} from "../../sagas/moduleCleContentSaga";

import {
  CANCEL_EVENT_REQUEST,
  CREATE_EVENT_REQUEST,
  DELETE_EVENT_REQUEST,
  DOWNLOAD_EVENT_ATTENDANCE_SHEET_REQUEST,
  DOWNLOAD_EVENTS_TEMPLATE_REQUEST,
  DUPLICATE_EVENT_REQUEST,
  EXPORT_BUDGET_REQUEST,
  EXPORT_EVENTS_EXCEL_REQUEST,
  FETCH_EVENTS_REQUEST,
  IMPORT_EVENTS_EXCEL_REQUEST,
  REPLANIFY_EVENT_REQUEST,
  SEND_EVENT_CALENDAR_REQUEST,
  UPDATE_EVENT_REQUEST,
} from "../../actions/eventsActions";
import {
  cancelEventSaga,
  createEventSaga,
  deleteEventSaga,
  downloadEventAttendanceSheetSaga,
  downloadEventsTemplateSaga,
  duplicateEventSaga,
  exportBudgetSaga,
  exportEventsExcelSaga,
  fetchEventsSaga,
  importEventsExcelSaga,
  replanifyEventSaga,
  sendEventCalendarSaga,
  updateEventSaga,
} from "../../sagas/eventsSaga";

import {
  BULK_ASSIGN_USERS_REQUEST,
  FETCH_ASSIGNABLE_USERS_REQUEST,
  FETCH_ASSIGNED_USERS_BY_EVENT_REQUEST,
  FETCH_ASSIGNED_USERS_BY_MODULE_REQUEST,
  REMOVE_ASSIGNMENT_REQUEST,
} from "../../actions/assignmentActions";
import {
  bulkAssignUsersSaga,
  fetchAssignableUsersSaga,
  fetchAssignedUsersByEventSaga,
  fetchAssignedUsersByModuleSaga,
  removeAssignmentSaga,
} from "../../sagas/assignmentSaga";

import {
  BULK_UPDATE_EVENT_ATTENDANCE_REQUEST,
  DECLARE_MY_EVENT_ABSENCE_REQUEST,
  FETCH_EVENT_ATTENDANCE_REQUEST,
} from "../../actions/eventAttendanceActions";
import {
  bulkUpdateEventAttendanceSaga,
  declareMyEventAbsenceSaga,
  fetchEventAttendanceSaga,
} from "../../sagas/eventAttendanceSaga";

import {
  CREATE_QUIZ_REQUEST,
  CREATE_QUESTION_REQUEST,
  DELETE_QUESTION_REQUEST,
  DELETE_QUIZ_REQUEST,
  GET_ALL_QUIZZES_REQUEST,
  GET_ATTEMPTS_BY_COLLABORATEUR_REQUEST,
  GET_QUESTIONS_BY_QUIZ_REQUEST,
  GET_QUIZ_ATTEMPT_REQUEST,
  GET_QUIZ_REQUEST,
  GET_QUIZZES_BY_MODULE_REQUEST,
  GET_QUIZZES_BY_TYPE_REQUEST,
  START_QUIZ_ATTEMPT_REQUEST,
  SUBMIT_QUIZ_ATTEMPT_REQUEST,
  UPDATE_QUESTION_REQUEST,
  UPDATE_QUIZ_REQUEST,
} from "../../actions/quizActions";
import {
  createQuestionSaga,
  createQuizSaga,
  deleteQuestionSaga,
  deleteQuizSaga,
  getAllQuizzesSaga,
  getAttemptsByCollaborateurSaga,
  getQuestionsByQuizSaga,
  getQuizAttemptSaga,
  getQuizSaga,
  getQuizzesByModuleSaga,
  getQuizzesByTypeSaga,
  startQuizAttemptSaga,
  submitQuizAttemptSaga,
  updateQuestionSaga,
  updateQuizSaga,
} from "../../sagas/quizSaga";

import {
  CREATE_CERTIFICAT_REQUEST,
  CREATE_CERTIFICAT_VERSION_REQUEST,
  DELETE_CERTIFICAT_REQUEST,
  FETCH_CERTIFICATS_REQUEST,
  FETCH_CERTIFICAT_PLACEHOLDERS_REQUEST,
  GENERATE_CERTIFICAT_PDF_REQUEST,
  UPDATE_CERTIFICAT_ACTIVATION_REQUEST,
  UPDATE_CERTIFICAT_ARCHIVE_REQUEST,
  UPDATE_CERTIFICAT_PUBLICATION_REQUEST,
  UPDATE_CERTIFICAT_REQUEST,
} from "../../actions/certificatsActions";
import {
  createCertificatSaga,
  createCertificatVersionSaga,
  deleteCertificatSaga,
  fetchCertificatPlaceholdersSaga,
  fetchCertificatsSaga,
  generateCertificatPdfSaga,
  updateCertificatActivationSaga,
  updateCertificatArchiveSaga,
  updateCertificatPublicationSaga,
  updateCertificatSaga,
} from "../../sagas/certificatsSagas";
import { FETCH_LEARNER_MODULES_REQUEST } from "../../actions/learnerModulesActions";
import {
  COMPLETE_LEARNER_CONTENT_REQUEST,
  FETCH_MODULE_PLAYER_REQUEST,
  START_LEARNER_CONTENT_REQUEST,
  START_LEARNER_MODULE_REQUEST,
  UPDATE_LEARNER_CONTENT_PROGRESS_REQUEST,
} from "../../actions/moduleLearningActions";
import { fetchLearnerModulesSaga } from "../../sagas/learnerModulesSaga";
import {
  completeLearnerContentSaga,
  fetchModulePlayerSaga,
  startLearnerContentSaga,
  startLearnerModuleSaga,
  updateLearnerContentProgressSaga,
} from "../../sagas/moduleLearningSaga";

import seuilPassageSaga from "../../sagas/seuilPassageSagas";
import formationSkillSaga from "../../sagas/formationSkillSaga";
import {downloadEntitiesTemplateSaga, exportEntitiesExcelSaga, importEntitiesExcelSaga} from "../entitesSaga";
import {
    DOWNLOAD_ENTITIES_TEMPLATE_REQUEST,
    EXPORT_ENTITIES_REQUEST,
    IMPORT_ENTITIES_EXCEL_REQUEST
} from "../../actions/entitesActions";

export default function* formationRootSaga() {
  yield all([
    takeLatest(FETCH_CAMPAGNES_REQUEST, fetchCampagnesSaga),
    takeLatest(FETCH_VISIBLE_CAMPAGNES_REQUEST, fetchVisibleCampagnesSaga),
    takeLatest(FETCH_AUTHORIZED_CAMPAGNES_REQUEST, fetchAuthorizedCampagnesSaga),
    takeLatest(FETCH_BUDGET_BY_CAMPAGNE_REQUEST, fetchBudgetByCampagneSaga),
    takeLatest(CREATE_CAMPAGNE_REQUEST, createCampagneSaga),
    takeLatest(UPDATE_CAMPAGNE_REQUEST, updateCampagneSaga),
    takeLatest(DELETE_CAMPAGNE_REQUEST, deleteCampagneSaga),

    takeLatest(FETCH_DOMAINES_REQUEST, fetchDomainesSaga),
    takeLatest(FETCH_THEMES_REQUEST, fetchThemesSaga),
    takeLatest(FETCH_THEMES_BY_DOMAINE_REQUEST, fetchThemesByDomaineSaga),
    takeLatest(CREATE_DOMAINE_REQUEST, createDomaineSaga),
    takeLatest(UPDATE_DOMAINE_REQUEST, updateDomaineSaga),
    takeLatest(DELETE_DOMAINE_REQUEST, deleteDomaineSaga),
    takeLatest(CREATE_THEME_REQUEST, createThemeSaga),
    takeLatest(UPDATE_THEME_REQUEST, updateThemeSaga),
    takeLatest(DELETE_THEME_REQUEST, deleteThemeSaga),
    takeLatest(DOWNLOAD_DOMAINES_TEMPLATE_REQUEST, downloadDomainesTemplateSaga),
    takeLatest(DOWNLOAD_THEMES_TEMPLATE_REQUEST, downloadThemesTemplateSaga),
    takeLatest(IMPORT_DOMAINES_EXCEL_REQUEST, importDomainesExcelSaga),
    takeLatest(IMPORT_THEMES_EXCEL_REQUEST, importThemesExcelSaga),

    takeLatest(FETCH_FORMATIONS_REQUEST, fetchFormationsSaga),
    takeLatest(CREATE_FORMATION_REQUEST, createFormationSaga),
    takeLatest(UPDATE_FORMATION_REQUEST, updateFormationSaga),
    takeLatest(DELETE_FORMATION_REQUEST, deleteFormationSaga),
    takeLatest(DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST, downloadTemplateSaga),
    takeLatest(IMPORT_FORMATIONS_EXCEL_REQUEST, importExcelSaga),
    takeLatest(EXPORT_FORMATIONS_REQUEST, exportExcelSaga),

    takeLatest(FETCH_CATALOGUES_REQUEST, fetchCataloguesSaga),
    takeLatest(CREATE_CATALOGUE_REQUEST, createCatalogueSaga),
    takeLatest(UPDATE_CATALOGUE_REQUEST, updateCatalogueSaga),
    takeLatest(DELETE_CATALOGUE_REQUEST, deleteCatalogueSaga),
    takeLatest(DOWNLOAD_ENTITIES_TEMPLATE_REQUEST, downloadEntitiesTemplateSaga),
      takeLatest(IMPORT_ENTITIES_EXCEL_REQUEST, importEntitiesExcelSaga),
      takeLatest(EXPORT_ENTITIES_REQUEST, exportEntitiesExcelSaga),
    takeLatest(GET_CAPSULES_REQUEST, getCapsulesSaga),
    takeLatest(GET_CAPSULE_REQUEST, getCapsuleSaga),
    takeLatest(CREATE_CAPSULE_REQUEST, createCapsuleSaga),
    takeLatest(UPDATE_CAPSULE_REQUEST, updateCapsuleSaga),
    takeLatest(DELETE_CAPSULE_REQUEST, deleteCapsuleSaga),
    takeLatest(GET_DOMAINES_REQUEST, getDomainesSaga),
    takeLatest(GET_THEMES_BY_DOMAINE_REQUEST, getThemesByDomaineSaga),

    takeLatest(GET_MY_DEMANDES_REQUEST, getMyDemandesSaga),
    takeLatest(GET_MY_FORMATION_DEMANDES_REQUEST, getMyFormationDemandesSaga),
    takeLatest(GET_CREATED_BY_ME_DEMANDES_REQUEST, getCreatedByMeDemandesSaga),
    takeLatest(GET_DEMANDE_TRACKING_REQUEST, getDemandeTrackingSaga),
    takeLatest(CREATE_DEMANDE_COLLAB_REQUEST, createDemandeCollabSaga),
    takeLatest(CREATE_DEMANDE_MANAGER_REQUEST, createDemandeManagerSaga),
    takeLatest(CREATE_DEMANDE_RF_REQUEST, createDemandeRfSaga),
    takeLatest(CREATE_EVENT_DEMANDE_BY_LEARNER_REQUEST, createEventDemandeByLearnerSaga),
    takeLatest(CREATE_EVENT_DEMANDE_BY_MANAGER_REQUEST, createEventDemandeByManagerSaga),
    takeLatest(CREATE_EVENT_DEMANDE_BY_RF_REQUEST, createEventDemandeByRfSaga),
    takeLatest(CANCEL_EVENT_DEMANDE_REQUEST, cancelEventDemandeSaga),
    takeLatest(WITHDRAW_EVENT_DEMANDE_REQUEST, withdrawEventDemandeSaga),
    takeLatest(CREATE_DEMANDE_MANAGER_BULK_REQUEST, createDemandeManagerBulkSaga),
    takeLatest(CREATE_DEMANDE_RF_BULK_REQUEST, createDemandeRfBulkSaga),
    takeLatest(GET_DEMANDE_MANAGER_INBOX_REQUEST, getDemandeManagerInboxSaga),
    takeLatest(GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST, getDemandesManagerCampagneSaga),
    takeLatest(GET_DEMANDE_RF_INBOX_REQUEST, getDemandeRfInboxSaga),
    takeLatest(GET_DEMANDES_CAMPAGNE_REQUEST, getDemandesCampagneSaga),
    takeLatest(DEMANDE_MANAGER_DECISION_REQUEST, demandeManagerDecisionSaga),
    takeLatest(DEMANDE_RF_DECISION_REQUEST, demandeRfDecisionSaga),
    takeLatest(DOWNLOAD_PLAN_FORMATION_REQUEST, downloadGeneratePlanFormationExcelSaga),
    takeLatest(DOWNLOAD_BILAN_FORMATION_REQUEST, downloadGenerateBilanCampagneExcelSaga),
    takeLatest(GET_COMPANY_DEMANDES_REQUEST, getCompanyDemandesSaga),
    takeLatest(FETCH_PARTICIPATION_CAMPAGNE_REQUEST, fetchParticipationCampagneSaga),
    takeLatest(RELANCE_WORKFLOW_DEMANDE_REQUEST, relanceWorkflowDemandeSaga),
    takeLatest(RELANCE_WORKFLOW_CAMPAGNE_REQUEST, relanceWorkflowCampagneSaga),
    takeLatest(PROLONGER_CAMPAGNE_REQUEST, prolongerCampagneSaga),
    takeLatest(RELANCE_PARTICIPATION_CAMPAGNE_REQUEST, relanceParticipationCampagneSaga),
    takeLatest(FETCH_FORMATIONS_BY_CATALOGUE_REQUEST, fetchFormationsByCatalogueSaga),

    takeLatest(FETCH_SALLES_REQUEST, fetchSallesSaga),
    takeLatest(CREATE_SALLE_REQUEST, createSalleSaga),
    takeLatest(UPDATE_SALLE_REQUEST, updateSalleSaga),
    takeLatest(DELETE_SALLE_REQUEST, deleteSalleSaga),

    takeLatest(FETCH_FOURNISSEURS_REQUEST, fetchFournisseursSaga),
    takeLatest(CREATE_FOURNISSEUR_REQUEST, createFournisseurSaga),
    takeLatest(UPDATE_FOURNISSEUR_REQUEST, updateFournisseurSaga),
    takeLatest(DELETE_FOURNISSEUR_REQUEST, deleteFournisseurSaga),

    takeLatest(FETCH_CONSULTANTS_REQUEST, fetchConsultantsSaga),
    takeLatest(CREATE_CONSULTANT_REQUEST, createConsultantSaga),
    takeLatest(UPDATE_CONSULTANT_REQUEST, updateConsultantSaga),
    takeLatest(DELETE_CONSULTANT_REQUEST, deleteConsultantSaga),

    takeLatest(FETCH_MODULES_CLE_REQUEST, fetchModulesCleSaga),
    takeLatest(CREATE_MODULE_CLE_REQUEST, createModuleCleSaga),
    takeLatest(UPDATE_MODULE_CLE_REQUEST, updateModuleCleSaga),
    takeLatest(DELETE_MODULE_CLE_REQUEST, deleteModuleCleSaga),
    takeLatest(DOWNLOAD_MODULE_CLE_TEMPLATE_REQUEST, downloadModuleCleTemplateSaga),
    takeLatest(IMPORT_MODULE_CLE_EXCEL_REQUEST, importModuleCleExcelSaga),

    takeLatest(GET_MODULE_REQUEST, getModuleSaga),
    takeLatest(GET_ALL_MODULES_REQUEST, getAllModulesSaga),
    takeLatest(GET_MODULES_BY_STATUS_REQUEST, getModulesByStatusSaga),
    takeLatest(GET_ROOT_MODULES_REQUEST, getRootModulesSaga),
    takeLatest(GET_CHILD_MODULES_REQUEST, getChildModulesSaga),
    takeLatest(CREATE_MODULE_REQUEST, createModuleSaga),
    takeLatest(UPDATE_MODULE_REQUEST, updateModuleSaga),
    takeLatest(DELETE_MODULE_REQUEST, deleteModuleSaga),

    takeLatest(GET_MODULE_SECTIONS_REQUEST, getModuleSectionsSaga),
    takeLatest(CREATE_MODULE_SECTION_REQUEST, createModuleSectionSaga),
    takeLatest(UPDATE_MODULE_SECTION_REQUEST, updateModuleSectionSaga),
    takeLatest(DELETE_MODULE_SECTION_REQUEST, deleteModuleSectionSaga),
    takeLatest(REORDER_MODULE_SECTIONS_REQUEST, reorderModuleSectionsSaga),

    takeLatest(GET_MODULECLE_CONTENTS_REQUEST, getModuleCleContentsSaga),
    takeLatest(GET_MODULECLE_CONTENT_REQUEST, getModuleCleContentSaga),
    takeLatest(CREATE_MODULECLE_CONTENT_REQUEST, createModuleCleContentSaga),
    takeLatest(UPDATE_MODULECLE_CONTENT_REQUEST, updateModuleCleContentSaga),
    takeLatest(DELETE_MODULECLE_CONTENT_REQUEST, deleteModuleCleContentSaga),
    takeLatest(REORDER_MODULECLE_CONTENTS_REQUEST, reorderModuleCleContentsSaga),

    takeLatest(FETCH_EVENTS_REQUEST, fetchEventsSaga),
    takeLatest(CREATE_EVENT_REQUEST, createEventSaga),
    takeLatest(UPDATE_EVENT_REQUEST, updateEventSaga),
    takeLatest(DELETE_EVENT_REQUEST, deleteEventSaga),
    takeLatest(CANCEL_EVENT_REQUEST, cancelEventSaga),
    takeLatest(REPLANIFY_EVENT_REQUEST, replanifyEventSaga),
    takeLatest(DUPLICATE_EVENT_REQUEST, duplicateEventSaga),
    takeLatest(EXPORT_BUDGET_REQUEST, exportBudgetSaga),
    takeLatest(IMPORT_EVENTS_EXCEL_REQUEST, importEventsExcelSaga),
    takeLatest(EXPORT_EVENTS_EXCEL_REQUEST, exportEventsExcelSaga),
    takeLatest(DOWNLOAD_EVENTS_TEMPLATE_REQUEST, downloadEventsTemplateSaga),
    takeLatest(SEND_EVENT_CALENDAR_REQUEST, sendEventCalendarSaga),
    takeLatest(DOWNLOAD_EVENT_ATTENDANCE_SHEET_REQUEST, downloadEventAttendanceSheetSaga),

    takeLatest(FETCH_ASSIGNABLE_USERS_REQUEST, fetchAssignableUsersSaga),
    takeLatest(FETCH_ASSIGNED_USERS_BY_EVENT_REQUEST, fetchAssignedUsersByEventSaga),
    takeLatest(FETCH_ASSIGNED_USERS_BY_MODULE_REQUEST, fetchAssignedUsersByModuleSaga),
    takeLatest(BULK_ASSIGN_USERS_REQUEST, bulkAssignUsersSaga),
    takeLatest(REMOVE_ASSIGNMENT_REQUEST, removeAssignmentSaga),

    takeLatest(FETCH_EVENT_ATTENDANCE_REQUEST, fetchEventAttendanceSaga),
    takeLatest(BULK_UPDATE_EVENT_ATTENDANCE_REQUEST, bulkUpdateEventAttendanceSaga),
    takeLatest(DECLARE_MY_EVENT_ABSENCE_REQUEST, declareMyEventAbsenceSaga),

    takeLatest(GET_QUIZ_REQUEST, getQuizSaga),
    takeLatest(GET_ALL_QUIZZES_REQUEST, getAllQuizzesSaga),
    takeLatest(GET_QUIZZES_BY_MODULE_REQUEST, getQuizzesByModuleSaga),
    takeLatest(GET_QUIZZES_BY_TYPE_REQUEST, getQuizzesByTypeSaga),
    takeLatest(CREATE_QUIZ_REQUEST, createQuizSaga),
    takeLatest(UPDATE_QUIZ_REQUEST, updateQuizSaga),
    takeLatest(DELETE_QUIZ_REQUEST, deleteQuizSaga),
    takeLatest(GET_QUESTIONS_BY_QUIZ_REQUEST, getQuestionsByQuizSaga),
    takeLatest(CREATE_QUESTION_REQUEST, createQuestionSaga),
    takeLatest(UPDATE_QUESTION_REQUEST, updateQuestionSaga),
    takeLatest(DELETE_QUESTION_REQUEST, deleteQuestionSaga),
    takeLatest(START_QUIZ_ATTEMPT_REQUEST, startQuizAttemptSaga),
    takeLatest(SUBMIT_QUIZ_ATTEMPT_REQUEST, submitQuizAttemptSaga),
    takeLatest(GET_QUIZ_ATTEMPT_REQUEST, getQuizAttemptSaga),
    takeLatest(GET_ATTEMPTS_BY_COLLABORATEUR_REQUEST, getAttemptsByCollaborateurSaga),

    takeLatest(FETCH_CERTIFICATS_REQUEST, fetchCertificatsSaga),
    takeLatest(FETCH_CERTIFICAT_PLACEHOLDERS_REQUEST, fetchCertificatPlaceholdersSaga),
    takeLatest(CREATE_CERTIFICAT_REQUEST, createCertificatSaga),
    takeLatest(UPDATE_CERTIFICAT_REQUEST, updateCertificatSaga),
    takeLatest(DELETE_CERTIFICAT_REQUEST, deleteCertificatSaga),
    takeLatest(CREATE_CERTIFICAT_VERSION_REQUEST, createCertificatVersionSaga),
    takeLatest(UPDATE_CERTIFICAT_ACTIVATION_REQUEST, updateCertificatActivationSaga),
    takeLatest(UPDATE_CERTIFICAT_PUBLICATION_REQUEST, updateCertificatPublicationSaga),
    takeLatest(UPDATE_CERTIFICAT_ARCHIVE_REQUEST, updateCertificatArchiveSaga),
    takeLatest(GENERATE_CERTIFICAT_PDF_REQUEST, generateCertificatPdfSaga),
    takeLatest(FETCH_LEARNER_MODULES_REQUEST, fetchLearnerModulesSaga),
    takeLatest(FETCH_MODULE_PLAYER_REQUEST, fetchModulePlayerSaga),
    takeLatest(START_LEARNER_MODULE_REQUEST, startLearnerModuleSaga),
    takeLatest(START_LEARNER_CONTENT_REQUEST, startLearnerContentSaga),
    takeEvery(UPDATE_LEARNER_CONTENT_PROGRESS_REQUEST, updateLearnerContentProgressSaga),
    takeLatest(COMPLETE_LEARNER_CONTENT_REQUEST, completeLearnerContentSaga),
  ]);

  yield fork(watchFormationBookmarksSaga);
  yield* seuilPassageSaga();
  yield* formationSkillSaga();
}
